<template>
  <div class="columns">
    <div class="is-full column">
      <h1>{{this.name}}</h1>
      <h2>Design by: {{this.designer}}</h2>
      <div class="gallery-item" v-bind:data-n="this.n">
        <div v-if="mobileurl !== ''" class="phone-container">
          <div class="phone">
            <div class="phone-inner">
              <div class="screen">
                <lazy-component @show="beginAnimation" v-bind:data-n="this.n+'p'">
                  <img :src="mobileurl" :alt="this.name + ' Mobile'"  />
                  <icon name="spinner" scale="3"></icon>
                </lazy-component>
                  
              </div>
            </div>
            <img src="static/mobile.png" class="phone-img" alt="Mobile View">
          </div>  
        </div>
        <div class="monitor-container">
          <div class="monitor">
            <div class="monitor-inner">
              <div class="screen">
                <lazy-component @show="beginAnimation"  v-bind:data-n="this.n+'m'">
                  <img :src="mainurl" :alt="this.name + ' Site'"  />
                  <icon name="spinner" scale="3"></icon>
                </lazy-component>
                
              </div>
            </div>
            <img src="static/desktop.png" class="monitor-img" alt="Desktop View">

          </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1, h2 {
  text-align:center;
}
h2 {
  font-family:'Raleway',sans-serif;
}
.gallery-item {
  img {
    width:100%;
  }
  position:relative;
  .monitor-container {
    position:relative;
    width:80%;
    margin-left:10%;
  }
  .phone-container {
    position:absolute;
    width:20%;
    bottom:20px;
    right:0px;
    z-index:5;
    box-shadow:0px 4px 2px -2px black;
  }
}
.phone {
  height:100%;
  width:100%;
  position:relative;
}
.phone-img {
  height:100%;
  width:100%;
}
.monitor {
  height:100%;
  width:100%;
  position:relative;
 }
.monitor-img, .phone-img {
  width:100%;
  height:100%;
}
.monitor .monitor-inner {
  position:absolute;
  margin-left:4.1%;
  margin-top:7.8%;
  height:62%;
  width: 92%;
   overflow:hidden;
}
.phone .phone-inner {
  position: absolute;
  margin-left:8.1%;
  margin-top:34.7%;
  overflow:hidden;
  width: 84.6%;
  height:65%;
}
.screen {
  position:relative;
  width:100%;
  height:100%;
  text-align:center;
  background-size: cover;
  background-color:black;
  img[lazy="loading"] + svg {
    position:absolute;
    top:30%;
    margin: 0px auto;
    width:100%;
    display:block;
    animation: SPIN 1000ms linear infinite;
  }
  img[lazy="loaded"] + svg {
    display:none;
  }
  div {
    width:100%;
    height:100%;
  }
}
@keyframes SPIN {
  0% {
    transform: rotate(0deg);
  }
  
  100% {
    transform: rotate(360deg);
  }
}

</style>
<script>
var animations = [];
var loadedImages = [];

export default {
  name: 'gallery-item',
  props: ['mainurl','mobileurl','name','designer', 'n'],
  methods: {
    animate: function() {
      

    },
    beginAnimation: function(component) {
      requestAnimationFrame(function() {
        let n = component.$el.getAttribute('data-n')
        let mirror = document.querySelector('.bmv-reflection .gallery div[data-n="'+n+'"]')
        if (mirror) {
          mirror.innerHTML = component.$el.innerHTML
        }
        let monitorSize = document.querySelector('.monitor-inner .screen').clientHeight
        if (n.indexOf('p') > -1) {
          monitorSize = document.querySelector('.phone-inner .screen').clientHeight
        }
        let img = document.querySelector('.bmv-reflective .gallery div[data-n="'+n+'"] img')
        // console.log(img.clientHeight)
        let imgs = document.querySelectorAll('.gallery div[data-n="'+n+'"] img')
        loadedImages.push(component)
        setTimeout(() => {
          imgs.forEach(function (element) {
            // console.log(element.clientHeight)
            let mDistance = element.clientHeight - monitorSize
            if (mDistance > 1) {
              animations.push(element.animate([
                {transform: 'translateY(0px)', easing: 'ease-in-out'},
                {transform: 'translateY(-'+mDistance+'px)', easing: 'ease-out'}], {
                duration: 8000,
                iterations: Infinity,
                direction: "alternate",
                delay: 0
              }))
            }
          })
        },2000)
       
      })
      
    },
    restartAnimations() {
      let tmpImages = loadedImages
      loadedImages = [];
      // console.log(tmpImages)
      tmpImages.forEach((el) => {
        this.beginAnimation(el)
      })
      
    },
    cancelAnimations() {
      animations.forEach((element) => {
        element.cancel()
      })
      animations = [];
      requestAnimationFrame(this.restartAnimations)
    }
  },
  mounted() {
    window.addEventListener('resize',this.cancelAnimations)
    // window.addEventListener('load',this.animate)
    
  }
}

</script>



// WEBPACK FOOTER //
// Galleryitem.vue?68420a6c